import api from './axios';

/**
 * Aylık ödeme (gider) çizelgesi.
 *
 * DİKKAT: bu uçlar personel maaşlarını döndürüyor. Sayfayı/menüyü açarken
 * `expense_schedules.view` iznine bağla; rol kontrolü tek başına yetmez
 * çünkü izin Yetkiler panelinden devredilebiliyor.
 */
export const getExpenseSchedules = (params) =>
  api.get('/expense-schedules', { params });

export const createExpenseSchedule = (data) =>
  api.post('/expense-schedules', data);

export const updateExpenseSchedule = (id, data) =>
  api.put(`/expense-schedules/${id}`, data);

/** "Para hazır" ve "ödendi" işaretleri — { ready?: bool, paid?: bool } */
export const setExpenseScheduleStatus = (id, data) =>
  api.patch(`/expense-schedules/${id}/durum`, data);

export const deleteExpenseSchedule = (id) =>
  api.delete(`/expense-schedules/${id}`);

/** Başka bir aydan kopyala — üstüne ekler, silmez. */
export const copyExpenseSchedule = (data) =>
  api.post('/expense-schedules/kopyala', data);
